import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import CredentialCardSet from '@nmx/template/dist/componentLibrary/modules/CredentialCardSet';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='investments-credential-callout-grouping'
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='credentials-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          The Northwestern Mutual <WidowBlock>investing difference</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <CredentialCardSet
      accentColorVariant='gold'
      accentOrientation='vertical'
      backgroundVariant='lightB'
      credentials={[
        {
          credential: 'rankedInvestmentService',
          sup1: 3,
        },
        {
          credential: 'numberOfClients',
          sup1: 4,
        },
        {
          credential: 'yearsOfService',
          sup1: <></>,
        },
      ]}
      hasAccent
      themeType='lightTheme'
    />
  </SectionContainer>
);
